import Component from './TrendIcon.vue';

export default {
  install(Vue) {
    Vue.component('BkfTrendIcon', Component);
  },
};
